import React, { Component } from "react";
import { connect } from "react-redux";
import SocialAccountList from "../../Transactions/Component/SocialAccountList";
import SocialAccountCard from "../../Transactions/Component/Social Account/SocialAccountCard";
import { DELETE_USER_SOCIAL_ACCOUNT, GET_SOCIAL_ACCOUNT_DATA } from "../../../../../actions/accountsActions";
import {  SWAL_FIRE, TOAST_DISMISS, TOAST_ERROR, TOAST_SUCCESS, baseUrl,isAppleSafari } from "../../../../../utils";
import AddAccountPopup from "../../Transactions/Component/Modals/AddAccountPopup";
import AccountHeading from "../../Transactions/Component/AccountHeading";
import IconComponent from "../../Transactions/Component/IconComponent";
import LoadingScreen from "../../../../CommonComponents/LoadingScreen";
import { addUserAccount } from "../../../../Authorization/SocialAuth/connectSocialAcc";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";
import { Button } from "react-bootstrap";

const channel = isAppleSafari() ? window : new BroadcastChannel('connect');
class SocialAccount extends Component {
  state = {
    allSocialAccounts: this.props.socialAccounts,
    addAccountPopup: false,
    shareAccount: false,
    errorShareAccount: null,
    isSharingEmail: false,
    isLoading: false,
    copyShareTxt: 'Copy to clipboard'
  };

  componentDidMount() {
    const { socialAccounts } = this.props;
    this.setState({ allSocialAccounts: socialAccounts });
    channel.addEventListener('message', this.readAuthenticationCode);
    setTimeout(() => { this.setState({ isLoading: true }) }, 1000);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.socialAccounts !== this.state.allSocialAccounts) {
      this.setState({ allSocialAccounts: nextProps.socialAccounts });
    }
    setTimeout(() => { this.setState({ isLoading: true }) }, 1000);
  }

  deleteSocialAccount = (item) => (event) => {
    SWAL_FIRE({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "#FF4051",
      cancelButtonColor: "#E4E6EF",
    }).then((result) => {
      if (result.value) {
        this.props.DELETE_USER_SOCIAL_ACCOUNT(item.ConnectedAccounts.id, item.Network.id, this.onSaveCallBack);
      } else if (result.dismiss === "cancel") {
      }
    });
  };

  onSaveCallBack = (errorMsg = null) => {
    if(!errorMsg){
      const { socialAccounts } = this.props;
      TOAST_SUCCESS("Account successfully disconnected.");
      this.setState({ allSocialAccounts: socialAccounts });
    }else TOAST_ERROR(errorMsg);
   
    setTimeout(() => TOAST_DISMISS(), 3000)
  };


  openAddAccountPopup = () => {
    const { addAccountPopup } = this.state;
    this.setState({ addAccountPopup: !addAccountPopup });
  };

  readAuthenticationCode = (event) => {
    const response = JSON.parse(event.data);
    const { data, networkId, type } = response;

    const reconnect = localStorage.getItem('refresh');
    let ownerId = localStorage.getItem('accountId');

    if (type == "connectAccount") {
      addUserAccount(networkId, data, () => this.props.getSocialAccounts(ownerId), ownerId, 0, Number(reconnect));
    }
    localStorage.removeItem('refresh');
  }

  componentWillUnmount() {
    channel.removeEventListener("message", this.readAuthenticationCode);
  }

  render() {
    const { allSocialAccounts, addAccountPopup, isLoading } = this.state;
    const { addAccountData } = this.props;
    const sData =
      allSocialAccounts &&
        allSocialAccounts.accountInformations &&
        allSocialAccounts.accountInformations.length > 0
        ? true
        : false;

    return (
      isLoading ?
        <>
        <div className="d-flex flex-column-fluid main_content account_info_wrap subheader_content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="screen_wrapper pb-10 pt-5">
                  <div className="tab-content">
                    <div id="connectedAccounts" className="tab-pane fade active show">
                      <h4 className="text-dark font-weight-bold mb-3">Social Accounts</h4>
                      <div className="card card-custom">
                        <div className="card-header flex-wrap py-3 justify-content-end">
                          <div className="card-toolbar">
                            <Button variant="primary"
                              data-bs-toggle="modal"
                              id="addAccount"
                              data-target="#addAccount"
                              onClick={this.openAddAccountPopup}
                            >
                              <IconComponent class_name="svg-icon svg-icon-md">
                                <FontAwesomeIcon type={'regular'} icon={'plus'} iconClass={'me-2'} />
                              </IconComponent>
                              Add Account
                            </Button>
                          </div>
                        </div>

                        <div className="card-body p-3">
                          {sData ? (
                            <div className="table-responsive">
                              <div className="accordion accordion-light accordion-svg-toggle conn_accounts_wrap"
                                id="connectedAccounts">
                                <SocialAccountList />
                                <div className="connectedAccounts">
                                  {allSocialAccounts &&
                                    allSocialAccounts.accountInformations.map(
                                      (item, index) => (
                                        <SocialAccountCard
                                          item={item}
                                          index={index}
                                          key={index}
                                          deleteSocialAccount={this.deleteSocialAccount}
                                        />
                                      )
                                    )}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="no_connected_acc">
                              <img
                                src={baseUrl(`products/product-empty.svg`)}
                                className="mb-10 img-fluid"
                              />
                              <AccountHeading title={"Account Not Connected"} />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        

          <AddAccountPopup
            openAddAccountPopup={this.openAddAccountPopup}
            addAccountPopup={addAccountPopup}
            addAccountData={addAccountData}
          />
        </>
        : <LoadingScreen />
    );
  }
}
const mapStateToProps = (state) => {
  return {
    addAccountData: state.userAccountData.addAccount,
    socialAccounts: state.userAccountData.socialAccounts,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    DELETE_USER_SOCIAL_ACCOUNT: (feedId, networkId, callBack) =>
      dispatch(DELETE_USER_SOCIAL_ACCOUNT(feedId, networkId, callBack)),
    getSocialAccounts: (userId) => dispatch(GET_SOCIAL_ACCOUNT_DATA(userId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SocialAccount);
